module.exports = __webpack_public_path__ + "static/img/v4-down_android.c2e266b5.png";